module.exports = __webpack_public_path__ + "static/IMG_2253-eeb653f873e0a165a8bfe04efaa184cb.jpg";